import { action } from 'satcheljs/lib/legacy';
import { areDateRangesEqual, DateRange } from 'owa-datetime-utils';
import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { isSameMonth, isSameWeek } from 'owa-datetime';
import { observableToday } from 'owa-observable-datetime';
import { selectedDateUpdated } from './selectedDateUpdated';

export let updateDateRange = action('updateDateRange')(function updateDateRange(
    newDateRange: DateRange,
    store: CalendarSurfaceStore,
    updateDateRangeOnly: boolean = false
): void {
    if (!areDateRangesEqual(newDateRange, store.dateRange)) {
        const today = observableToday();
        store.dateRange = newDateRange;

        // The caller's updateDateRangeOnly (forceUpdate) is set to true in only two cases
        // 1. During a deeplink scenario
        // 2. During a scenario wherein user changes the setting of their workdays, first day of week etc.
        // In both these scenarios, there seems to be no need to update the selected date.
        if (!updateDateRangeOnly) {
            if (store.dateRangeType == DateRangeType.Month) {
                store.selectedDate = isSameMonth(newDateRange.start, today)
                    ? today
                    : newDateRange.start;
            } else if (
                store.dateRangeType == DateRangeType.Week ||
                store.dateRangeType == DateRangeType.WorkWeek
            ) {
                store.selectedDate = isSameWeek(
                    newDateRange.start,
                    today,
                    store.userOptions.weekStartDay
                )
                    ? today
                    : newDateRange.start;
            } else {
                // default dateRangeType == day
                store.selectedDate = newDateRange.start;
            }
        }
        selectedDateUpdated(store.selectedDate);
    }
});
